import { ThemeOptions } from "@mui/material";
import {
  MuiButton,
  MuiChip,
  MuiFilledInput,
  styleRootCommonAppBar,
  zeroBorderRadius
} from "./util/theme-generator-util";
import { INFO_DARK, INFO_LIGHT, INFO_MAIN, SUCCESS_DARK } from "./util/variables";

export const mmntFontFamilyTitle = "MMNT";
export const mmntFontFamilyBody = "Inter";

export const mmntThemeConfig: ThemeOptions = {
  components: {
    MuiChip,
    MuiButton,
    MuiFilledInput,
    MuiAppBar: {
      styleOverrides: {
        root: styleRootCommonAppBar
      }
    }
  },
  shape: {
    borderRadius: zeroBorderRadius
  },
  palette: {
    primary: {
      main: "#222222"
    },
    secondary: {
      main: "#7DC1AD"
    },
    success: {
      main: "#7DC1AD",
      light: "#AFCAC2",
      dark: SUCCESS_DARK
    },
    info: {
      main: INFO_MAIN,
      light: INFO_LIGHT,
      dark: INFO_DARK
    },
    background: {
      default: "#EFEFEF",
      paper: "#FFFFFF"
    },
    text: {
      primary: "#222222",
      secondary: "#222222"
    },
    action: {
      disabledOpacity: 0
    }
  },
  typography: {
    fontFamily: mmntFontFamilyBody,
    h1: {
      fontStyle: "normal",
      fontWeight: "700",
      fontFamily: mmntFontFamilyTitle,
      fontSize: "32px",
      lineHeight: "38px",
      letterSpacing: "normal",
      textTransform: "uppercase"
    },
    h2: {
      fontStyle: "normal",
      fontWeight: "700",
      fontFamily: mmntFontFamilyTitle,
      fontSize: "24px",
      lineHeight: "28px",
      letterSpacing: "normal",
      textTransform: "uppercase"
    },
    h3: {
      fontStyle: "normal",
      fontWeight: "700",
      fontFamily: mmntFontFamilyBody,
      fontSize: "20px",
      lineHeight: "24px",
      letterSpacing: "normal"
    },
    h4: {
      fontStyle: "normal",
      fontWeight: "700",
      fontFamily: mmntFontFamilyBody,
      fontSize: "16px",
      lineHeight: "20px",
      letterSpacing: "normal"
    },
    subtitle1: {
      fontStyle: "normal",
      fontWeight: "400",
      fontFamily: mmntFontFamilyBody,
      fontSize: "24px",
      lineHeight: "28px",
      letterSpacing: "normal"
    },
    body1: {
      fontFamily: mmntFontFamilyBody,
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "20px"
    },
    body2: {
      fontFamily: mmntFontFamilyBody,
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "14px"
    },
    caption: {
      fontFamily: mmntFontFamilyBody,
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "16px"
    }
  }
};
